import React from "react"
import ReactSVG from "react-svg"
import InstacartLogo from "../../../images/dashboard/instacart-short.svg"

const DiscountRibbon = ({ title }) => {
  return (
    <div className="discount-ribbon">
      <ReactSVG src={InstacartLogo} />
      <p className="ribbon-text">{title}</p>
    </div>
  )
}

export default DiscountRibbon
